import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-advisor-banner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './advisor-banner.component.html',
  styleUrls: ['./advisor-banner.component.css'],
})
export class AdvisorBannerComponent {
  get isActive(): boolean {
    return localStorage.getItem('asesorActivo') === 'true';
  }

  exit(): void {
    localStorage.removeItem('asesorActivo');
    localStorage.removeItem('portalToken');
    this.redirectToRayocolAcceso();
  }

  /** Aislado en su propio método para poder espiarlo en tests sin redefinir `window.location`,
   * que Chrome real no permite reconfigurar. */
  private redirectToRayocolAcceso(): void {
    window.location.href = `${environment.frontRayocolUrl}/asesor/acceso`;
  }
}
